/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * - `created` webhook has been recently created, pending initial health check
- `healthy` webhook is active and there are no delivery issues
- `unhealthy` webhook is in degraded state and deliveries are being retried
- `error` webhook is in error state and deliveries are suspended
- `removed` webhook has been removed
 */
export type WebhookStatus = typeof WebhookStatus[keyof typeof WebhookStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebhookStatus = {
  created: 'created',
  healthy: 'healthy',
  unhealthy: 'unhealthy',
  error: 'error',
  removed: 'removed',
} as const;
